export const mapMasterToGreenID = {
	unit_number: 'flatNumber',
	street_number: 'streetNumber',
	street_name: 'streetName',
	street_type: 'streetType',
	city: 'suburb',
	state: 'state',
	country: 'country',
	postcode: 'postcode',
};

export const mapGreenIDToMaster = {
	flatNumber: 'unit_number',
	streetNumber: 'street_number',
	streetName: 'street_name',
	streetType: 'street_type',
	suburb: 'city',
	state: 'state',
	country: 'country',
	postcode: 'postcode',
};

export const states = {
	NZ: [
		{ label: 'Northland', value: 'Northland' },
		{ label: 'Auckland', value: 'Auckland' },
		{ label: 'Waikato', value: 'Waikato' },
		{ label: 'Bay of Plenty', value: 'Bay of Plenty' },
		{ label: 'Gisborne', value: 'Gisborne' },
		{ label: "Hawke's Bay", value: "Hawke's Bay" },
		{ label: 'Taranaki', value: 'Taranaki' },
		{ label: 'Manawatū-Whanganui', value: 'Manawatu-Whanganui' },
		{ label: 'Wellington', value: 'Wellington' },
		{ label: 'Tasman', value: 'Tasman' },
		{ label: 'Nelson', value: 'Nelson' },
		{ label: 'Marlborough', value: 'Marlborough' },
		{ label: 'West Coast', value: 'West Coast' },
		{ label: 'Canterbury', value: 'Canterbury' },
		{ label: 'Otago', value: 'Otago' },
		{ label: 'Southland', value: 'Southland' },
	],
	AU: [
		{ label: 'NSW', value: 'NSW' },
		{ label: 'VIC', value: 'VIC' },
		{ label: 'QLD', value: 'QLD' },
		{ label: 'SA', value: 'SA' },
		{ label: 'WA', value: 'WA' },
		{ label: 'ACT', value: 'ACT' },
		{ label: 'NT', value: 'NT' },
		{ label: 'TAS', value: 'TAS' },
	],
	// Argument for this to be JSON format is strong
	US: [
		{ label: 'Alabama', value: 'AL' },
		{
			label: 'Alaska',
			value: 'AK',
		},
		{
			label: 'American Samoa',
			value: 'AS',
		},
		{
			label: 'Arizona',
			value: 'AZ',
		},
		{
			label: 'Arkansas',
			value: 'AR',
		},
		{
			label: 'California',
			value: 'CA',
		},
		{
			label: 'Colorado',
			value: 'CO',
		},
		{
			label: 'Connecticut',
			value: 'CT',
		},
		{
			label: 'Delaware',
			value: 'DE',
		},
		{
			label: 'District Of Columbia',
			value: 'DC',
		},
		{
			label: 'Federated States Of Micronesia',
			value: 'FM',
		},
		{
			label: 'Florida',
			value: 'FL',
		},
		{
			label: 'Georgia',
			value: 'GA',
		},
		{
			label: 'Guam',
			value: 'GU',
		},
		{
			label: 'Hawaii',
			value: 'HI',
		},
		{
			label: 'Idaho',
			value: 'ID',
		},
		{
			label: 'Illinois',
			value: 'IL',
		},
		{
			label: 'Indiana',
			value: 'IN',
		},
		{
			label: 'Iowa',
			value: 'IA',
		},
		{
			label: 'Kansas',
			value: 'KS',
		},
		{
			label: 'Kentucky',
			value: 'KY',
		},
		{
			label: 'Louisiana',
			value: 'LA',
		},
		{
			label: 'Maine',
			value: 'ME',
		},
		{
			label: 'Marshall Islands',
			value: 'MH',
		},
		{
			label: 'Maryland',
			value: 'MD',
		},
		{
			label: 'Massachusetts',
			value: 'MA',
		},
		{
			label: 'Michigan',
			value: 'MI',
		},
		{
			label: 'Minnesota',
			value: 'MN',
		},
		{
			label: 'Mississippi',
			value: 'MS',
		},
		{
			label: 'Missouri',
			value: 'MO',
		},
		{
			label: 'Montana',
			value: 'MT',
		},
		{
			label: 'Nebraska',
			value: 'NE',
		},
		{
			label: 'Nevada',
			value: 'NV',
		},
		{
			label: 'New Hampshire',
			value: 'NH',
		},
		{
			label: 'New Jersey',
			value: 'NJ',
		},
		{
			label: 'New Mexico',
			value: 'NM',
		},
		{
			label: 'New York',
			value: 'NY',
		},
		{
			label: 'North Carolina',
			value: 'NC',
		},
		{
			label: 'North Dakota',
			value: 'ND',
		},
		{
			label: 'Northern Mariana Islands',
			value: 'MP',
		},
		{
			label: 'Ohio',
			value: 'OH',
		},
		{
			label: 'Oklahoma',
			value: 'OK',
		},
		{
			label: 'Oregon',
			value: 'OR',
		},
		{
			label: 'Palau',
			value: 'PW',
		},
		{
			label: 'Pennsylvania',
			value: 'PA',
		},
		{
			label: 'Puerto Rico',
			value: 'PR',
		},
		{
			label: 'Rhode Island',
			value: 'RI',
		},
		{
			label: 'South Carolina',
			value: 'SC',
		},
		{
			label: 'South Dakota',
			value: 'SD',
		},
		{
			label: 'Tennessee',
			value: 'TN',
		},
		{
			label: 'Texas',
			value: 'TX',
		},
		{
			label: 'Utah',
			value: 'UT',
		},
		{
			label: 'Vermont',
			value: 'VT',
		},
		{
			label: 'Virgin Islands',
			value: 'VI',
		},
		{
			label: 'Virginia',
			value: 'VA',
		},
		{
			label: 'Washington',
			value: 'WA',
		},
		{
			label: 'West Virginia',
			value: 'WV',
		},
		{
			label: 'Wisconsin',
			value: 'WI',
		},
		{
			label: 'Wyoming',
			value: 'WY',
		},
	],
};

export const commonStreetTypes = [
	{ label: 'Street', value: 'Street' },
	{ label: 'Road', value: 'Road' },
	{ label: 'Alley', value: 'Alley' },
	{ label: 'Approach', value: 'Approach' },
	{ label: 'Arcade', value: 'Arcade' },
	{ label: 'Avenue', value: 'Avenue' },
	{ label: 'Boulevard', value: 'Boulevard' },
	{ label: 'Bypass', value: 'Bypass' },
	{ label: 'Causeway', value: 'Causeway' },
	{ label: 'Circuit', value: 'Circuit' },
	{ label: 'Circus', value: 'Circus' },
	{ label: 'Close', value: 'Close' },
	{ label: 'Corner', value: 'Corner' },
	{ label: 'Court', value: 'Court' },
	{ label: 'Cove', value: 'Cove' },
	{ label: 'Crescent', value: 'Crescent' },
	{ label: 'Drive', value: 'Drive' },
	{ label: 'End', value: 'End' },
	{ label: 'Esplanade', value: 'Esplanade' },
	{ label: 'Freeway', value: 'Freeway' },
	{ label: 'Frontage', value: 'Frontage' },
	{ label: 'Gardens', value: 'Gardens' },
	{ label: 'Glade', value: 'Glade' },
	{ label: 'Glen', value: 'Glen' },
	{ label: 'Grove', value: 'Grove' },
	{ label: 'Heights', value: 'Heights' },
	{ label: 'Highway', value: 'Highway' },
	{ label: 'Lane', value: 'Lane' },
	{ label: 'Link', value: 'Link' },
	{ label: 'Loop', value: 'Loop' },
	{ label: 'Mall', value: 'Mall' },
	{ label: 'Mews', value: 'Mews' },
	{ label: 'Parade', value: 'Parade' },
	{ label: 'Park', value: 'Park' },
	{ label: 'Parkway', value: 'Parkway' },
	{ label: 'Place', value: 'Place' },
	{ label: 'Promenade', value: 'Promenade' },
	{ label: 'Reserve', value: 'Reserve' },
	{ label: 'Ridge', value: 'Ridge' },
	{ label: 'Rise', value: 'Rise' },
	{ label: 'Row', value: 'Row' },
	{ label: 'Square', value: 'Square' },
	{ label: 'Strip', value: 'Strip' },
	{ label: 'Terrace', value: 'Terrace' },
	{ label: 'Thoroughfare', value: 'Thoroughfare' },
	{ label: 'Track', value: 'Track' },
	{ label: 'View', value: 'View' },
	{ label: 'Vista', value: 'Vista' },
	{ label: 'Walk', value: 'Walk' },
	{ label: 'Walkway', value: 'Walkway' },
	{ label: 'Way', value: 'Way' },
	{ label: 'Yard', value: 'Yard' },
	{ label: 'Other', value: 'Other' },
];
